import { makeUrl } from "expo-linking";



import { NavigationContainer } from "@react-navigation/native";
import React from "react";
import SplashScreen from "../components/SplashScreen";
import { authSelector } from "../redux/auth/authSelector";
import { createStackNavigator } from "@react-navigation/stack";
import { useSelector } from "react-redux";
import PrivateScreens from "./components/PrivateScreens";
import { FetchProvider } from "../context/fetch";
import { RateEntryProvider } from "../context/rate-entry";
import { Login } from "../../public/auth";
import { ForgotPassword } from "../../public/forgot-password";
import { useActiveSession } from "../../public/auth/infrastructure/store/fetch-context";

const prefix = makeUrl("/");
const AuthNavigation = createStackNavigator();

const AuthScreens: React.FC = () => (
  <AuthNavigation.Navigator headerMode="none" >
    <AuthNavigation.Screen
      name="login"
      component={Login}
      options={{
        title: "Carrier Approvals - Login",
        cardStyle: {
          backgroundColor: 'transparent',
        }
      }}
    />
    <AuthNavigation.Screen
      name="forgot-password"
      component={ForgotPassword}
      options={{ title: "Carrier Approvals - Forgot Password" }}
    />
  </AuthNavigation.Navigator>
);

const Navigation: React.FC = () => {
  const linking = {
    prefixes: [ prefix ],
  };

  const { user = {}, didTryAutoLogin } = useSelector(authSelector);
  const activeSession = useActiveSession()

  // usePusher(user as UserSessionI);

  if (Object.keys(user).length === 0 && !didTryAutoLogin) return <SplashScreen />;

  return (
      <NavigationContainer linking={linking}>
        <RateEntryProvider>
          <FetchProvider>{activeSession ? <PrivateScreens /> : <AuthScreens />}</FetchProvider>
        </RateEntryProvider>
      </NavigationContainer>
  );
};

export default Navigation;
